import React from 'react';
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import MapComponent from '../../../components/Map';

const BasicInformationStep = ({ 
  formData, 
  setFormData, 
  locations, 
  handleCountryChange, 
  handleCityChange,
  mapCenter,
  setMapCenter,
  t 
}) => {
  const handleChange = (field) => (event) => {
    setFormData(prev => ({ ...prev, [field]: event.target.value }));
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label={t('editRoommate.listingTitle')}
          value={formData.listingTitle}
          onChange={handleChange('listingTitle')}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <FormControl fullWidth>
          <InputLabel>{t('editRoommate.country')}</InputLabel>
          <Select
            value={formData.country}
            onChange={handleCountryChange}
            label={t('editRoommate.country')}
          >
            {locations.countries.map((country) => (
              <MenuItem key={country.id} value={country.id}>
                {country.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={4}>
        <FormControl fullWidth>
          <InputLabel>{t('editRoommate.city')}</InputLabel>
          <Select
            value={formData.city}
            onChange={handleCityChange}
            label={t('editRoommate.city')}
          >
            {locations.cities.map((city) => (
              <MenuItem key={city.id} value={city.id}>
                {city.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={4}>
        <FormControl fullWidth>
          <InputLabel>{t('editRoommate.district')}</InputLabel>
          <Select
            value={formData.district}
            onChange={handleChange('district')}
            label={t('editRoommate.district')}
          >
            {locations.districts.map((district) => (
              <MenuItem key={district.id} value={district.id}>
                {district.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          label={t('editRoommate.address')}
          value={formData.address}
          onChange={handleChange('address')}
          multiline
          rows={3}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label={t('editRoommate.monthlyRent')}
          type="number"
          value={formData.monthlyRent}
          onChange={handleChange('monthlyRent')}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label={t('editRoommate.availableFrom')}
            value={formData.availableFrom}
            onChange={(newValue) => setFormData(prev => ({ ...prev, availableFrom: newValue }))}
            renderInput={(params) => <TextField {...params} fullWidth />}
          />
        </LocalizationProvider>
      </Grid>

      <Grid item xs={12}>
        <MapComponent
          address={formData.address}
          mapCenter={mapCenter}
          setMapCenter={setMapCenter}
          onAddressChange={handleChange('address')}
          onLocationSelect={(location) => {
            setFormData(prev => ({
              ...prev,
              ...location
            }));
          }}
          addressInputProps={{
            render: ({ value, onChange, inputProps }) => (
              <TextField
                fullWidth
                label={t('editRoommate.address')}
                value={value}
                onChange={onChange}
                multiline
                rows={3}
                {...inputProps}
              />
            )
          }}
        />
      </Grid>
    </Grid>
  );
};

export default BasicInformationStep; 